<template>
  <q-layout view="hHh lpR fFf">

    <q-header elevated class="bg-primary text-white" bordered>
      <q-toolbar>
        <q-btn dense flat round icon="menu" @click="drawer = !drawer" v-if="valUser.IsLogged && valUser.TipoUsuario!=3"/>

        <q-toolbar-title>
          <q-avatar square size="30px">
            <img src="../src/assets/img/escudo.svg">
          </q-avatar>
          SICOPE
        </q-toolbar-title>
        <q-btn stretch flat label="Iniciar Sesión" icon="login" to="/cuenta/login" v-if="!valUser.IsLogged && blogin"/>
        <q-btn-dropdown stretch flat icon="account_circle" :label="valUser.Nombre" v-if="valUser.IsLogged">
        <q-list>
          <!--<q-item-label header>Administrador</q-item-label>-->
           <q-item clickable v-close-popup tabindex="0" v-if="valUser.TipoUsuario!=3">
            <q-item-section avatar>
              <q-avatar icon="vpn_key" color="secondary" text-color="white" />
            </q-item-section>
            <q-item-section @click="iniResetPWD">
              <q-item-label>Cambiar Contraseña</q-item-label>
            </q-item-section>
          </q-item>
          <q-separator inset  />
          <q-item clickable v-close-popup tabindex="0" v-if="valUser.TipoUsuario!=3">
            <q-item-section avatar>
              <q-avatar icon="logout" color="negative" text-color="white" />
            </q-item-section>
            <q-item-section @click="logOut">
              <q-item-label>Cerrar Sesión</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup tabindex="0" v-if="valUser.TipoUsuario==3"><!--Cerrar sesion Servidor público-->
            <q-item-section avatar>
              <q-avatar icon="logout" color="negative" text-color="white" />
            </q-item-section>
            <q-item-section @click="logOutSP">
              <q-item-label>Cerrar Sesión</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
      </q-toolbar>
    </q-header>
    <q-drawer show-if-above v-model="drawer" side="left" dark  bordered v-if="valUser.IsLogged && valUser.TipoUsuario!=3">
      <div class="absolute-top" align="center">
        <q-img  src="../src/assets/img/secretariaFP.svg" style="width: 75%" />
      </div>
      <q-scroll-area style="height: calc(100% - 150px); margin-top: 160px; border-right: 0px">
      <!-- <q-scroll-area style="height: calc(100% - 150px); margin-top: 0px; border-right: 0px"> -->
      <q-list>
          <template v-for="menuItem in menuList" :key="menuItem.id">
            <q-item v-if="menuItem.list.length==0 && menuItem.visible.includes(valUser.TipoUsuario)" v-show="menuItem.visible" clickable  v-ripple  href="#" :to="menuItem.path" active-class="text-primary">
              <q-item-section avatar>
                <q-icon :name="menuItem.icon" />
              </q-item-section>
              <q-item-section>
                <q-item-label> {{ menuItem.label }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-expansion-item v-else-if="menuItem.list.length !=0 && menuItem.visible.includes(valUser.TipoUsuario)" :icon="menuItem.icon" v-show="menuItem.visible" :label="menuItem.label">
              <q-list class="q-pl-lg">
                <template v-for="menuList in menuItem.list" :key="menuList.id">
                  <q-item clickable v-ripple href="#" v-if="menuList.visible.includes(valUser.TipoUsuario)" :to="menuList.path" active-class="text-primary">
                    <q-item-section avatar>
                      <q-icon :name="menuList.icon" />
                    </q-item-section>
                    <q-item-section>
                      <q-item-label> {{ menuList.label }}</q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-list>
            </q-expansion-item>
            <q-separator v-if="menuItem.visible.includes(valUser.TipoUsuario)"/>
          </template>
      </q-list>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>

    <q-footer elevated class="bg-grey-12 text-primary">
      <q-toolbar inset>
        <div>Gobierno del Estado de Chiapas - Administración 2024 - 2030</div>
        <q-space />
        <q-btn stretch flat label="Aviso De Privacidad"  @click="aviso=true"/>
      </q-toolbar>
    </q-footer>

    <q-dialog v-model="aviso" persistent>
     <q-card style="width: 700px; max-width: 80vw;">
     <!--<q-card style="min-width: 80%; min-height:80%;">-->
        <q-toolbar class="bg-dark text-white">
          <q-toolbar-title>Aviso de Privacidad</q-toolbar-title>
          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>
        <q-card-section><div align="justify">
          La Unidad de Apoyo Administrativo de la Secretaría de Finanzas Públicas, es responsable del manejo, 
          custodia y protección de los datos personales que en su caso nos proporcione y serán protegidos 
          conforme a lo dispuesto por la Ley de Protección de Datos Personales en Posesión de Sujetos 
          Obligados del Estado de Chiapas. Estos datos serán incorporados y tratados exclusivamente 
          para fines de difusión de información acerca del tratamiento, así como para el acceso, 
          ratificación, cancelación y oposición en materia de datos personales, se pone a su disposición 
          el aviso de privacidad integral para su consulta en Internet en la dirección electrónica siguiente: 
          <a href="https://www.haciendachiapas.gob.mx/SitioNuevo/aviso-de-privacidad" target="_blank">
            https://www.haciendachiapas.gob.mx/SitioNuevo/aviso-de-privacidad
          </a>.</div>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="valLoader" persistent>
    <q-card>
      <q-card-section class="row items-center">
       <q-spinner-cube color="primary" size="5em" />
      </q-card-section>
    </q-card>
  </q-dialog>

 
     <q-dialog v-model="bResetPwd" persistent>
        <q-card style="width:700px; max-width:80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>Cambiar Contraseña</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="resetPWD">
                    <q-input outlined dense v-model="reset.Password" label="Contraseña" type="password" :rules="rules"/>
                    <q-input outlined dense v-model="reset.ConfirmPassword" label="Confirmar" type="password" :rules="rules"/>
                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="bResetPwd=false"/>
                            <q-btn color="primary" label="Guardar" type="submit"/>
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>

    


  </q-layout>
</template>

<script>
import { ref } from 'vue'
import {mapState} from 'vuex';
import { mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import http from "@/services/http"
import $router from '@/router';

export default {

data: () => ({
      drawer: ref(false),
      miniState: ref(true),
      blogin:false,
      rules: [v => !!v || 'Campo obligatorio',],
      reset:{IdUsuario:0,Password:'',ConfirmPassword:'' },
      bResetPwd:false,
      menuList : [
        {
          visible: [0,1,2],
          icon: 'home',
          label: 'Inicio',
          path: '/',
          list:[]
        },
        {
          visible: [0,1],
          icon: 'today',
          label: 'Calendario',
          list: [
            {
              visible: [0,1],
              icon: 'event',
              label: 'Días Festivos',
              path: '/calendario/festivos',
            },
            {
              visible: [0,1],
              icon: 'public',
              label: 'Justificación Global',
              path: '/calendario/justificacion',
            }
          ]
        },
        // {
        //   icon: 'analytics',
        //   label: 'Estadísticas',
        //   path: '/estadisticas',
        //   list:[]
        // },
        {
          visible: [0,1],
          icon: 'book',
          label: 'Catálogos',
          list: [
            {
              visible: [0],
              icon: 'devices',
              label: 'Dispositivos',
              path: '/catalogos/dispositivos',
            },
            {
              visible: [0,1],
              icon: 'schedule',
              label: 'Horarios',
              path: '/catalogos/horarios',
            },
            {
              visible: [0,1],
              icon: 'style',
              label: 'Incidencias',
              path: '/catalogos/incidencias',
            },
            {
              visible: [0,1],
              icon: 'place',
              label: 'Lugar de Checado',
              path: '/catalogos/lugaresChecado',
            },
             {
              visible: [0,1],
              icon: 'date_range',
              label: 'Periodo Vacacional',
              path: '/catalogos/periodos',
            },
          ]
        },
        {
          visible: [0,1,2],
          icon: 'people',
          label: 'Personal',
          path: '/personal',
          list:[]
        },
        {
          visible: [0,1],
          icon: 'print',
          label: 'Reportes',
          path: '/reportes',
          list:[]
        },
        {
          visible: [0,1],
          icon: 'settings',
          label: 'Configuración',
          list: [
            {
              visible: [0,1],
              icon: 'sync',
              label: 'Actualizar BD',
              path: '/configuracion/actualizacion',
            },
            {
              visible: [0,1],
              icon: 'manage_accounts',
              label: 'Usuarios',
              path: '/configuracion/usuarios',
            }
          ]
        },
      ],
      aviso : ref(false),
    }),
   methods:{
     ...mapActions(['loadUser']),
     ...mapMutations(['logOut']),
     iniResetPWD(){
       var obj = JSON.parse(localStorage.getItem('sicope-user'));
       this.reset.IdUsuario= obj.IdUsuario;
       this.reset.Password='';
       this.reset.ConfirmPassword='';
       this.bResetPwd = true;
     },
     async resetPWD(){
        await http.post('cuenta/resetpwd',this.reset);
        this.bResetPwd = false;
    },
     async logOutSP(){
        localStorage.clear()
      await $router.push('/visor')
      location.reload()
     }
    },

     computed:{
            ...mapState(['loader','user']),
            valLoader(){
                return this.loader
            },
            valUser(){
              return this.user
            }
        },
    created(){
    this.loadUser()

    //console.log(rs.$store.state.user.TipoUsuario);
  },
  watch:{
    $route (to, from){
      if(to.name=="Login" ||to.name=="LoginVisor"){
        this.blogin= false;
      }else{
        this.blogin= true;
      }
    }
} 

}
</script>

<style>
@font-face {
  font-family: GothamBook;
  src: url('../src/assets/fonts/GothamBook.ttf') format('truetype');
}
html{
  user-select: none;
}
body{
  font-family: GothamBook;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
   background: #ededed;   
}
::-webkit-scrollbar-thumb {
  background: #333333; 
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #333333; 
}


.q-table tbody td{
  background: rgba(0,0,0,0.03);
}
.q-table tr:hover td {
    /*background-color: #f0f0f0;*/
    -webkit-filter: brightness(90%);
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
}

.m-3{
  margin: 3px;
}

</style>